import type { FaireProductEntity } from "../../entity_types/product";

export const p_nn8pnb85xq: FaireProductEntity = {
  token: "p_nn8pnb85xq",
  type: "product",
  name: "Cookies and Cream Fudge",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/92fa9cfb26482faed13bf2b0633be8c7c61b2fd2cab63a98724589261512998b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/798baef77fe773eb8afb5da3518fce7f188143ea68231210c7b4bcaebd22066b.jpeg",
  ],
  priceDollars: 7.58,
  description:
    "This recipe for Cookies and Cream Fudge is very simple. We take crunched-up chocolate cookies and toss them into hot vanilla fudge. After it cools, the cookies are trapped and waiting for you. It’s a great combination. FREE SHIPPING on all orders over $55. \n\nCookies And Cream Fudge in a 1/2 pound resealable tub.\n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:03.637Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
